import type { MisconceptionDefinition } from '../types'

export const gewichtMisconceptions: MisconceptionDefinition[] = [
  {
    id: 'met.weegschaal-gewicht-per-stuk-misverstand',
    label: 'Totaalgewicht als gewicht-per-stuk gelezen',
    module: 'Metriek',
    description:
      'Leerling leest het totaalgewicht op de weegschaal als het gewicht van één stuk (of omgekeerd).',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-optellen-en-vermenigvuldigen',
    label: 'Optellen én vermenigvuldigen gecombineerd',
    module: 'Metriek',
    description:
      'Leerling telt gewichten op én vermenigvuldigt het resultaat (dubbele bewerking) bij weegschaal-vraagstukken.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-vermenigvuldigd-ipv-opgeteld',
    label: 'Vermenigvuldigt i.p.v. optellen bij toevoeging',
    module: 'Metriek',
    description:
      'Leerling vermenigvuldigt de twee gewichten i.p.v. ze op te tellen wanneer er iets bij de weegschaal wordt gelegd.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-aftrekken-ipv-optellen',
    label: 'Aftrekken i.p.v. optellen bij toevoeging',
    module: 'Metriek',
    description:
      'Leerling trekt het toegevoegde gewicht af van het bestaande gewicht i.p.v. het erbij op te tellen.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.gewicht-aftreksom-fout',
    label: 'Aftreksom verkeerd uitgevoerd bij gewicht',
    module: 'Metriek',
    description:
      'Leerling maakt een rekenfout bij de aftreksom in een gewicht-context-opgave.',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-optellen-ipv-aftrekken',
    label: 'Gewicht opgeteld i.p.v. afgetrokken',
    module: 'Metriek',
    description:
      'Leerling telt gewichten op waar afgetrokken moet worden (bijv. resterend gewicht na verbruik).',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-kg-naar-g-fout',
    label: 'kg naar g conversie fout in context',
    module: 'Metriek',
    description:
      'Leerling vergeet of past de kg→g conversie (×1000) verkeerd toe in een gewicht-context-opgave.',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-fiets-overschat-100g',
    label: 'Fiets-gewicht overschat als 100 g',
    module: 'Metriek',
    description:
      'Leerling schat een fiets op een orde van grootte rond 100 g i.p.v. ~15 kg.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-munt-overschat-100g',
    label: 'Munt-gewicht overschat als 100 g',
    module: 'Metriek',
    description:
      'Leerling schat een munt op een orde van grootte rond 100 g i.p.v. enkele grammen.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-stoel-onderschat-100g',
    label: 'Stoel-gewicht onderschat als 100 g',
    module: 'Metriek',
    description:
      "Leerling schat een stoel op een orde van grootte rond 100 g i.p.v. enkele kilo's.",
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-volgorde-schooltas-appel',
    label: 'Schooltas en appel in verkeerde volgorde',
    module: 'Metriek',
    description:
      'Leerling rangschikt een schooltas en een appel naar gewicht in de verkeerde volgorde.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-volgorde-munt-appel',
    label: 'Munt en appel in verkeerde volgorde',
    module: 'Metriek',
    description:
      'Leerling rangschikt een munt en een appel naar gewicht in de verkeerde volgorde.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-volgorde-richting-fout',
    label: 'Volgorde-richting verwisseld bij gewicht-rangschikking',
    module: 'Metriek',
    description:
      'Leerling rangschikt voorwerpen van zwaar naar licht terwijl licht naar zwaar gevraagd was (of omgekeerd).',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-decimaal-genegeerd',
    label: 'Decimaal deel van gewicht genegeerd',
    module: 'Metriek',
    description:
      'Leerling vergeet het decimale deel (bijv. de halve kilo) bij het optellen of aftrekken van gewichten.',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-naar-boven-afgerond',
    label: 'Naar boven afgerond i.p.v. naar beneden',
    module: 'Metriek',
    description:
      'Leerling rondt het aantal eenheden naar boven af waar naar beneden hoort (bijv. hoeveel zakken er passen).',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-schatting-fout',
    label: 'Verkeerde schatting bij gewicht-context',
    module: 'Metriek',
    description:
      'Leerling schat het aantal of de hoeveelheid verkeerd in bij een gewicht-context-opgave.',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-gebruikt-als-rest',
    label: 'Gebruikt deel als rest gegeven',
    module: 'Metriek',
    description:
      'Leerling geeft het gebruikte gewicht als antwoord in plaats van de rest.',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-eenheid-niet-omgerekend',
    label: 'Eenheid niet omgerekend voor bewerking',
    module: 'Metriek',
    description:
      'Leerling vergeet kg naar g om te rekenen voordat een bewerking (bijv. delen) wordt uitgevoerd.',
    typicalFamilies: ['MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gewicht-schooltas-schatten-fout',
    label: 'Schooltas-gewicht buiten realistische range geschat',
    module: 'Metriek',
    description:
      'Leerling schat het gewicht van een schooltas buiten de realistische range.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-koe-schatten-fout',
    label: 'Koegewicht buiten realistische range geschat',
    module: 'Metriek',
    description:
      'Leerling schat het gewicht van een koe buiten de realistische range.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-referentie-deling-fout',
    label: 'Fout bij deling met referentiegewicht',
    module: 'Metriek',
    description:
      'Leerling maakt een rekenfout bij delen om met een referentiegewicht te vergelijken.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-volwassene-schatten-fout',
    label: 'Volwassene-gewicht buiten realistische range geschat',
    module: 'Metriek',
    description:
      'Leerling schat het gewicht van een volwassene buiten de realistische range.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-pen-overschat-1kg',
    label: 'Pen overschat als 1 kg',
    module: 'Metriek',
    description:
      'Leerling denkt dat een pen ongeveer 1 kg weegt — orde van grootte fout.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-auto-onderschat-1kg',
    label: 'Auto onderschat als 1 kg',
    module: 'Metriek',
    description:
      'Leerling denkt dat een auto ongeveer 1 kg weegt (verwart kg en ton).',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-telefoon-overschat-1kg',
    label: 'Telefoon overschat als 1 kg',
    module: 'Metriek',
    description:
      'Leerling denkt dat een telefoon ongeveer 1 kg weegt — orde van grootte fout.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.gewicht-banaan-schatten-fout',
    label: 'Banaangewicht buiten realistische range geschat',
    module: 'Metriek',
    description:
      'Leerling schat het gewicht van een banaan buiten de realistische range.',
    typicalFamilies: ['MET-GEW-SCHATTEN'],
  },
  {
    id: 'met.weegschaal-toevoeging-genegeerd',
    label: 'Toevoeging genegeerd op weegschaal',
    module: 'Metriek',
    description:
      'Leerling denkt dat het totaalgewicht niet verandert als er iets bij wordt gelegd.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-eerste-gewicht-genegeerd',
    label: 'Eerste gewicht genegeerd',
    module: 'Metriek',
    description:
      'Leerling kijkt alleen naar het toegevoegde gewicht en negeert het al aanwezige gewicht.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-eenheid-fout',
    label: 'Verkeerde eenheid bij weegschaal-antwoord',
    module: 'Metriek',
    description:
      'Leerling geeft het antwoord in kg waar gram gevraagd is (of omgekeerd) bij weegschaal-vraagstukken.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-evenwicht-gemist',
    label: 'Evenwicht-relatie gemist',
    module: 'Metriek',
    description:
      'Leerling denkt dat elk gewicht apart gelijk is aan het totaal i.p.v. dat de twee zijden in evenwicht zijn.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-aantal-verkeerd',
    label: 'Verkeerd aantal gewichten gebruikt',
    module: 'Metriek',
    description:
      'Leerling deelt door het verkeerde aantal gewichten bij evenwicht-berekening.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-extra-gewicht-opgeteld',
    label: 'Extra gewicht onterecht opgeteld',
    module: 'Metriek',
    description:
      'Leerling telt een extra gewicht op dat er in werkelijkheid niet ligt.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-aantal-genegeerd',
    label: 'Aantal gewichten genegeerd',
    module: 'Metriek',
    description:
      'Leerling kijkt slechts naar één gewicht en negeert hoe vaak het voorkomt.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-aantal-als-antwoord',
    label: 'Aantal gewichten als totaal gegeven',
    module: 'Metriek',
    description: 'Leerling verwart het aantal gewichten met het totaalgewicht.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-optellen-fout',
    label: 'Rekenfout bij optellen van gewichten',
    module: 'Metriek',
    description:
      'Leerling maakt een rekenfout bij het optellen van meerdere gewichten op de weegschaal.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.weegschaal-kleine-gewichten-genegeerd',
    label: 'Kleine gewichten genegeerd',
    module: 'Metriek',
    description:
      'Leerling kijkt alleen naar het grootste gewicht en negeert de kleinere gewichten.',
    typicalFamilies: ['MET-GEW-WEGEN'],
  },
  {
    id: 'met.gew-trap-te-weinig',
    label: 'Te weinig treden bij gewicht-conversie',
    module: 'Metriek',
    description:
      'Leerling rekent te weinig treden op het metrieke trapje (×100 of ×10 i.p.v. ×1.000 bij kg↔g, of ÷100/÷10 i.p.v. ÷1.000) — onderschat hoeveel stappen er tussen twee eenheden zitten.',
    typicalFamilies: ['MET-GEW-OMREKEN', 'MET-GEW-CONTEXT'],
  },
  {
    id: 'met.gew-trap-te-veel',
    label: 'Te veel treden bij gewicht-conversie',
    module: 'Metriek',
    description:
      'Leerling rekent te veel treden op het metrieke trapje (×10.000 i.p.v. ×1.000, of ÷10.000 i.p.v. ÷1.000) — overschat hoeveel stappen er tussen twee eenheden zitten (denkt vaak aan mg-niveau).',
    typicalFamilies: ['MET-GEW-OMREKEN', 'MET-GEW-CONTEXT'],
  },
]
